export const Bio = {
  name: "Sambit Dutta",
  roles: ["Programmer", "Front End Developer", "ML Enthusiast"],
  description:
    "I'm a motivated and adaptable individual with a passion for learning, committed to delivering top-notch results. Armed with a positive attitude and a growth mindset, I'm poised to make a meaningful contribution and achieve greatness.",
  github: "https://github.com/sambitd2003",
  resume:
    "https://drive.google.com/file/d/1FXyyuPZ0meRbCy9tYaiFSI6jTKfP5SWE/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sambit-dutta-b64997227/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "ReactJS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image: "https://v4.mui.com/static/logo.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "NodeJS",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "ExpressJS",
        image:
          "https://w7.pngwing.com/pngs/925/447/png-transparent-express-js-node-js-javascript-mongodb-node-js-text-trademark-logo.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "TensorFlow 2.0",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Tensorflow_logo.svg/1915px-Tensorflow_logo.svg.png",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Keras_logo.svg/1200px-Keras_logo.svg.png",
      },
      {
        name: "Google Colab",
        image: "https://colab.research.google.com/img/colab_favicon_256px.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.codeclause.com/assets/img/Main%20Logo.png",
    role: "Web Development Intern",
    company: "CodeClause",
    date: "July 2023",
    desc: "Worked on various front-end projects using languages like HTML, CSS and JavaScript",
    skills: ["HTML", "CSS", "JavaScript"],
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/C560BAQHSg7aKruYptA/company-logo_200_200/0/1661313752568/learnasyougo_logo?e=2147483647&v=beta&t=37Fr_mrlBhB-AFAz_Tv21U35MqUsPYAo2YcdpElszPA",
    role: "Subject Matter Expert",
    company: "LearnAsYouGo",
    date: "July 2023 - Sep 2023",
    desc: "Selected for real-time doubt solving (Mathematics) internship",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i1.wp.com/iemgroup.s3.amazonaws.com/uploads/2017/12/IEM_New_Logo.jpg?fit=1458%2C1190&ssl=1",
    school: "Institute of Engineering & Management",
    date: "2021 - 2025",
    grade: "9.53 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science Engineering (Artificial Intelligence) at Institute of Engineering & Management, Kolkata. I have completed 5 semesters and have a YGPA of 8.98. I have taken courses in Data Structures and Algorithms, Object Oriented Programming, Database Management Systems, Operating Systems and Computer Networks among others.",
    degree: "B.Tech, CSE (AI)",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/6/6e/SouthPointSchoolLogo.jpg",
    school: "South Point High School",
    date: "2021",
    grade: "95.2%",
    desc: "I completed my higher secondary education at South Point High School, Kolkata, where I studied Science with Computer Science and Mathematics.",
    degree: "CBSE (XII)",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/en/6/6e/SouthPointSchoolLogo.jpg",
    school: "South Point High School",
    date: "2019",
    grade: "95.4%",
    desc: "I completed my primary education at South Point High School, Kolkata.",
    degree: "CBSE (X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "Movix",
    date: "2023",
    description:
      "Movix is a web application built using ReactJS and Redux that allows users to search for movies and TV shows, view popular, trending and upcoming releases on a daily and weekly basis.",
    image: "https://i.ytimg.com/vi/VLgVw2NEqCM/maxresdefault.jpg",
    tags: ["ReactJS", "Redux", "SCSS"],
    category: "web app",
    github: "https://github.com/sambitd2003/movix",
    webapp: "https://movix-cpa.pages.dev/",
  },
  {
    id: 1,
    title: "The Fit Club",
    date: "2023",
    description:
      "Made a fully responsive website for a fitness center with animations and email updation. For contact, we will use the EmailJS library to make this site more functional and practical.",
    image: "https://i.morioh.com/2023/06/11/93e5526b.webp",
    tags: ["ReactJS", "CSS", "HTML"],
    category: "web app",
    github: "https://github.com/sambitd2003/the-fit-club",
    webapp: "https://the-fit-club-beta.vercel.app/",
  },
  {
    id: 7,
    title: "Titanic Survival Prediction",
    date: "2023",
    description:
      "In this project, we will predict the survival chances of the Titanic passengers using the given information about their sex, age, etc. As this is a classification task we will be using logistic regression.",
    image:
      "https://media.licdn.com/dms/image/C5112AQFoudi-QicfuQ/article-cover_image-shrink_600_2000/0/1547395172108?e=2147483647&v=beta&t=OHEwb7hyLe_5VnhqQUejgpbA9hnzdmhhOSLS25Mmyjk",
    tags: ["Python", "Logistic Regression", "Naive Bayes"],
    category: "machine learning",
    github:
      "https://github.com/sambitd2003/predicting-the-survival-of-titanic-passengers",
    webapp:
      "https://colab.research.google.com/drive/1VqcVvWHPLcZz03uKqq5dTLwwZ1FY5tJl?usp=sharing",
  },
  {
    id: 2,
    title: "Spotify",
    date: "2023",
    description:
      "This music player will have all the features found in a typical music player. You will be able to add, play, pause and seek songs that have been added.",
    image:
      "https://s3-alpha.figma.com/hub/file/2080541657/12505004-d908-4c3f-83fa-eac7bdebcdc4-cover.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/sambitd2003/spotify-clone",
    webapp: "https://sambitd2003.github.io/spotify-clone/",
  },
  {
    id: 8,
    title: "House Price Prediction",
    date: "2023",
    description:
      "Consider a real estate company that has a dataset containing the prices of properties. It wishes to use the data to optimise the sale prices of the properties based on important factors such as area, bedrooms, parking, etc.",
    image: "https://miro.medium.com/v2/resize:fit:1400/0*cDRFtpTiOJFrfzS5.jpg",
    tags: ["Python", "Linear Regression", "Scikit-learn"],
    category: "machine learning",
    github:
      "https://github.com/sambitd2003/house-price-prediction-using-linear-regression",
    webapp:
      "https://colab.research.google.com/drive/1TFR2a_wvNMyBUt6NBZXwWs7Iby0TEEKT?usp=sharing",
  },
  {
    id: 6,
    title: "Dog vs Cat Classification",
    date: "2024",
    description:
      "This project is about building a Dog vs Cat classification system using Transfer Learning. Here we used the pre-trained model called MobileNet V2.",
    image:
      "https://storage.googleapis.com/kaggle-media/competitions/kaggle/3362/media/woof_meow.jpg",
    tags: ["Python", "Keras", "TensorFlow"],
    category: "machine learning",
    github:
      "https://github.com/sambitd2003/dog-vs-cat-classification-using-transfer-learning",
    webapp:
      "https://colab.research.google.com/drive/1shQIaFiJaPCiGP505hYVHoI-nrwFPYCO?usp=sharing",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
